@use '@lib/assets/styles/main.scss' as *;

.input {
  [class*='rightIconWrap'] {
    color: $success900;
  }
}

.title {
  @include responsive($md1) {
    margin-bottom: 48px;
  }
  @include responsive(null, $md1) {
    text-align: center;
    margin-bottom: 40px;
  }
  & + .text {
    @include responsive($md1) {
      margin-top: -40px;
    }
    @include responsive(null, $md1) {
      margin-top: -32px;
    }
  }
}

.text {
  margin-bottom: 8px;
}

.textLast {
  margin-bottom: 48px;
}

.loginWrap {
  height: 100%;
  @include responsive(null, $md1) {
    padding-bottom: 68px;
    position: relative;
  }
}

.loginActions {
  @include responsive(null, $md1) {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.resetPasswordForm {
  height: 100%;
  display: grid;
  grid-template-rows: min-content auto;
}

.forgotPasswordActions {
  @include responsive(null, $md1) {
    position: absolute;
    bottom: 12px;
    left: 16px;
    right: 16px;
  }
}

.forgotPassword {
  text-align: right;
  a {
    line-height: 45px;
    height: 45px;
  }
}
